export default __webpack_public_path__ + "static/media/markerPolylineBlue.b1a5d724.svg";